<template>
	<div grey-back full-height class="settings_tab">

       <div grey-back class="pb-2">

            <!-- <v-list two-line style="padding:4px 0px" v-if="$root.CurrentBusiness"> -->
            <v-list two-line :three-line="$root.clientConnectionStatus == 'Connected' ? true : false" nopadding v-if="$root.CurrentBusiness">

              <!-- <v-alert @click="$root.fn_openExternalUrl('https://bizopsapp.com/freeaccess')" type="info" icon="info_outline" style="height:48px;background-color:  rgba(66, 165, 245, 0.2) !important;" :value="true">
                <span class="ml-3">Lifetime <span font-medium>FREE</span> for single business use</span>
              </v-alert> -->

              <v-subheader @click="$root.fn_openExternalUrl('https://bizopsapp.com/freeaccess')" font-normal dark-opacity-color style="background-color:  rgba(66, 165, 245, 0.2) !important;height: 48px;">
                <v-icon color="primary">info_outline</v-icon>
                <span class="ml-4">Lifetime <span font-medium>FREE</span> for single business use</span>
                <v-spacer></v-spacer>
                <v-icon color="primary">chevron_right</v-icon>
              </v-subheader>

              <!-- <v-list-tile>

                <v-list-tile-content>
                    <v-list-tile-title>BizOps App is Lifetime FREE for single business use <v-chip color="success" small>Free</v-chip></v-list-tile-title>
                </v-list-tile-content>

              </v-list-tile> -->



              <template v-if="$root.CurrentBusiness.UserType == 2">

                <v-card flat style="margin: 16px;border-radius: 10px;background:#E1F5FE;">
                  <v-card-text @click="fn_sendInvite" style="padding: 16px;">
                    <div style="width: 54px;height:54px;border-radius: 50%;float: left;background:rgba(75, 119, 190, 0.6);">
                      <img style="width: 100%;height:100%;padding:2px;" src="../../assets/accounting_icon.svg"/>
                    </div>
                    <div style="padding-left: 72px;font-size: 16px;padding-top: 2px;font-weight: 500;">
                      Provide accounting &amp; billing services to your Clients easily
                    </div>
                  </v-card-text>
                  <v-card-actions @click="fn_sendInvite" style="padding: 8px 16px 16px;">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" style="padding-left: 12px;" capitalize small>Get Started 
                      <v-icon right style="margin-left: 4px;font-size: 20px;color: #ffffff !important;">keyboard_arrow_right</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>

                <!-- <v-alert @click="$router.push('/settings/sendinvitation')" type="info" icon="info" style="height:48px" :value="true">Access your Clients Business data for Free</v-alert>

                <v-list-tile white-background avatar v-ripple @click="$router.push('/settings/sendinvitation')">

                  <v-list-tile-action>
                      <v-icon class="primary-color">groups</v-icon>
                  </v-list-tile-action>

                  <v-list-tile-content>
                      <v-list-tile-title>Invite Clients</v-list-tile-title>
                      <v-list-tile-sub-title>Access clients business data</v-list-tile-sub-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                      <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                  </v-list-tile-action>

                </v-list-tile> -->


                <!-- <v-list-tile white-background avatar margin-top-ten v-ripple @click="fn_businessDetails">

                  <v-list-tile-avatar class="avatar-with-background">
                      {{$root.fn_abbreviatedName($root.CurrentBusiness.UserName)}}
                  </v-list-tile-avatar>

                  <v-list-tile-content>
                      <v-list-tile-title>{{$root.CurrentBusiness.UserName}}</v-list-tile-title>
                      <v-list-tile-sub-title>View details</v-list-tile-sub-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                  </v-list-tile-action>

                </v-list-tile> -->

              </template>

              <v-subheader subheader-dense v-if="$root.CurrentBusiness.UserType == 2">Profile</v-subheader>

              <v-list-tile avatar v-ripple @click="fn_businessDetails" v-if="!$root.CurrentBusiness.IsAccountantOnly">

                  <v-list-tile-avatar class="avatar-with-background" v-if="$root.CurrentBusiness.businessLogo">
                    <img :src="$root.CurrentBusiness.businessLogo"/>
                      <!-- <img :src="$root.CurrentBusiness.businessLogo" v-if="$root.CurrentBusiness.businessLogo"/> -->
                      <!-- <template v-else>{{$root.fn_abbreviatedBusinessName()}}</template> -->
                  </v-list-tile-avatar>

                  <v-list-tile-action v-else>
                      <v-icon class="primary-color">store</v-icon>
                  </v-list-tile-action>

                  <v-list-tile-content>
                      <v-list-tile-title>{{$root.CurrentBusiness.BusinessName}}</v-list-tile-title>
                      <v-list-tile-sub-title>View business details</v-list-tile-sub-title>
                      <v-chip v-if="$root.clientConnectionStatus == 'Connected'" color="success" style="color: #ffffff;" small class="mt-1 ml-0">Remote Connection</v-chip>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                  </v-list-tile-action>
              
              </v-list-tile>

            </v-list>

            <v-alert style="height:48px" :value="true" color="info pt-0 pb-0" :class="{'pr-0':!isBackupRunning}" transition="slide-y-transition" v-if="$root.unsyncedItemsCount && !$root.CurrentBusiness.IsAccountantOnly">
              <v-layout row wrap style="align-items:center">
                <v-flex xs8 sm8 md8>{{$root.unsyncedItemsCount}} unsync {{$root.unsyncedItemsCount == 1 ? 'record' : 'records'}}</v-flex>
                <v-flex xs4 sm4 md4 right-align>
                  <template v-if="isBackupRunning && $root.fn_internetStatus()">
                    <v-progress-circular :size="24" :width="2" indeterminate color="primary"></v-progress-circular>
                    <div style="font-size:8px">Data sync in progress...</div>
                  </template>
                  <v-btn capitalize flat v-else @click="fn_syncNow">Sync Now</v-btn>
                </v-flex>
              </v-layout>
            </v-alert>

            <!-- <v-divider></v-divider>

            <v-list nopadding>
              <v-list-tile>
                  <v-list-tile-action>
                      <v-icon class="primary-color">date_range</v-icon>
                  </v-list-tile-action>

                  <v-list-tile-content>
                      <v-list-tile-title>Opening Date</v-list-tile-title>
                  </v-list-tile-content>

                  <v-list-tile-action v-ripple @click="fn_openDialogDatePicker">
                      <span class="primary-color"><u><strong>{{openingDate | moment("DD-MMM-YYYY")}}</strong></u></span>
                  </v-list-tile-action>
              </v-list-tile>
            </v-list> -->

            <v-list nopadding v-if="$root.CurrentBusiness && $root.CurrentBusiness.IsAccountantOnly">
              
              <v-list-tile v-ripple @click="fn_businessDetails">

                <v-list-tile-action>
                    <v-icon class="primary-color">person_outline</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                    <v-list-tile-title>View Details</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                </v-list-tile-action>

              </v-list-tile>

              <v-divider></v-divider>

              <v-list-tile v-ripple @click="fn_updateBusiness('register')">
                  <v-list-tile-action>
                      <v-icon class="primary-color">store</v-icon>
                  </v-list-tile-action>

                  <v-list-tile-content>
                      <v-list-tile-title>Register Business</v-list-tile-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                      <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                  </v-list-tile-action>
              </v-list-tile>
            </v-list>

            <!-- <v-divider v-if="$root.CurrentBusiness.IsAccountantOnly"></v-divider> -->
            <v-divider v-if="$root.CurrentBusiness.UserType == 2"></v-divider>

            <v-list nopadding :class="{'margin-top-ten':$root.CurrentBusiness.UserType == 1}">
              <v-list-tile v-ripple @click="fn_businessProfileSettings">
                  <v-list-tile-action>
                      <v-icon class="primary-color">settings</v-icon>
                  </v-list-tile-action>

                  <v-list-tile-content>
                      <v-list-tile-title>Settings</v-list-tile-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                      <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                  </v-list-tile-action>
              </v-list-tile>

              <v-list-tile to="/settings/configurations" v-if="false">
                  <v-list-tile-action>
                      <v-icon class="primary-color">settings_applications</v-icon>
                  </v-list-tile-action>

                  <v-list-tile-content>
                      <v-list-tile-title>Advanced Settings</v-list-tile-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                      <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                  </v-list-tile-action>
              </v-list-tile>
            </v-list>

            <!-- <v-list nopadding margin-top-ten>
              <v-list-tile @click="$root.fn_openSupport('customer')">
                <v-list-tile-action>
                    <v-icon class="primary-color">help_outline</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>Get Support</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                      <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                  </v-list-tile-action>
              </v-list-tile>

              <v-divider v-if="userType=='IsSupportUser' || userType=='IsDeveloper'"></v-divider>

              <v-list-tile @click="$root.fn_openSupport('support')" v-if="userType=='IsSupportUser' || userType=='IsDeveloper'">
                <v-list-tile-action>
                    <v-icon class="primary-color">portrait</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>Provide Support</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                      <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                  </v-list-tile-action>
              </v-list-tile>

            </v-list> -->

          <v-list nopadding margin-top-ten>

            <v-subheader v-if="$root.CurrentBusiness.IsAccountantOnly">More</v-subheader>

            <v-list-tile v-ripple @click="fn_checkNotificationPermissionStatus">
                <v-list-tile-action>
                    <v-icon class="primary-color">computer</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                    <v-list-tile-title>Desktop Login</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                    <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                </v-list-tile-action>
            </v-list-tile>

            <!-- <v-divider></v-divider>

            <v-list-tile v-ripple @click="fn_openDialogConfirmation('Disconnect')" v-if="$root.clientConnectionStatus == 'Connected'">
                <v-list-tile-action>
                    <v-icon class="primary-color">close</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                    <v-list-tile-title>Disconnect Client Business</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                    <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                </v-list-tile-action>
            </v-list-tile>

            <v-list-tile v-ripple to="/settings/business/items" v-else>
                <v-list-tile-action>
                    <v-icon class="primary-color">group</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                    <v-list-tile-title>Client Businesses</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                    <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                </v-list-tile-action>
            </v-list-tile> -->

            <!-- <v-divider></v-divider>

            <v-list-tile v-ripple @click="fn_connectionRequests">
                <v-list-tile-action>
                    <v-icon class="primary-color">link</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                    <v-list-tile-title>Connection Requests</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                    <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                </v-list-tile-action>
            </v-list-tile> -->

            <v-divider></v-divider>

            <v-list-tile v-ripple @click="fn_accountant" v-if="!$root.CurrentBusiness.IsAccountantOnly">
                <v-list-tile-action>
                    <v-icon class="primary-color">account_circle</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                    <v-list-tile-title>Accountant Access</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                    <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                </v-list-tile-action>
            </v-list-tile>

            <v-divider v-if="!$root.CurrentBusiness.IsAccountantOnly"></v-divider>

            <template>

              <v-list-tile v-ripple to="/settings/utilities">
                  <v-list-tile-action>
                      <v-icon class="primary-color">build</v-icon>
                  </v-list-tile-action>

                  <v-list-tile-content>
                      <v-list-tile-title>Utilities</v-list-tile-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                      <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                  </v-list-tile-action>
              </v-list-tile>

              <v-divider></v-divider>
            </template>

            <!-- <v-list-tile v-ripple @click="fn_languageSelection">
                <v-list-tile-action>
                    <v-icon class="primary-color">language</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                    <v-list-tile-title>Change Language</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                    <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                </v-list-tile-action>
            </v-list-tile>

            <v-divider></v-divider> -->

            <v-list-tile v-ripple @click="fn_sendFeedback">
                <v-list-tile-action>
                    <img src="../../assets/feedback-icon.svg" alt="">
                </v-list-tile-action>

                <v-list-tile-content>
                    <v-list-tile-title>Send Feedback</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                    <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                </v-list-tile-action>
            </v-list-tile>

            <v-divider></v-divider>

            <v-list-tile v-ripple @click="fn_shareApp">
                <v-list-tile-action>
                  <v-icon class="primary-color">share</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>Share App</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                </v-list-tile-action>
            </v-list-tile>

            <v-divider></v-divider>

            <v-list-tile v-ripple @click="fn_openDialogRating">
                <v-list-tile-action>
                    <v-icon class="primary-color">star_outline</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                    <v-list-tile-title>Rate App</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                    <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                </v-list-tile-action>
            </v-list-tile>

            <v-divider></v-divider>

            <v-list-tile to="/settings/about" v-ripple>
                <v-list-tile-action>
                    <v-icon class="primary-color">info_outline</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                    <v-list-tile-title>About</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                    <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                </v-list-tile-action>
            </v-list-tile>
            <v-divider></v-divider>

            <v-list-tile to="/settings/security" v-ripple>
                <v-list-tile-action>
                    <v-icon class="primary-color">lock_outline</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                    <v-list-tile-title>Security</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                    <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                </v-list-tile-action>
            </v-list-tile>


          </v-list>

          <v-list nopadding margin-top-ten>
            <v-subheader class="pr-1" subheader-semi-dense>
              Need Help?
              <v-spacer></v-spacer>
              <v-menu bottom left>
                <v-btn small nopadding slot="activator" icon>
                    <v-icon font20>more_horiz</v-icon>
                </v-btn>

                <v-list dense nopadding>
                    <v-list-tile @click="$root.fn_openSupport('customer')">
                      <v-list-tile-title>Ticket Support</v-list-tile-title>
                    </v-list-tile>
                </v-list>

              </v-menu>
            </v-subheader>
            <v-list-tile @click="$root.fn_openExternalUrl('https://www.youtube.com/@BizOpsApp/videos')">
                <v-list-tile-action>
                  <v-icon class="primary-color">help_outline</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>Watch Help Videos</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                </v-list-tile-action>
            </v-list-tile>

            <!-- <v-divider></v-divider>

            <v-list-tile @click="$root.fn_openSupport('customer')">
                <v-list-tile-action>
                    <img src="../../assets/icon_contact_support.svg" alt="contact_support"/>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>Get Ticket Support</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                    <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                </v-list-tile-action>
            </v-list-tile> -->

            <v-divider></v-divider>

            <v-list-tile @click="fn_redirectToWhatsApp">
                <v-list-tile-action>
                    <v-icon class="primary-color">chat</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>Chat with us</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                    <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                </v-list-tile-action>
            </v-list-tile>

            <v-divider></v-divider>

            <v-list-tile @click="fn_requestCall">
                <v-list-tile-action>
                    <v-icon class="primary-color">phone_in_talk</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>Talk to us</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                    <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                </v-list-tile-action>
            </v-list-tile>

            <v-divider v-if="userType=='IsSupportUser'"></v-divider>
              <!-- || userType=='IsDeveloper' -->

            <v-list-tile @click="$root.fn_openSupport('support')" v-if="userType=='IsSupportUser'">
                <v-list-tile-action>
                    <v-icon class="primary-color">portrait</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>Provide Support</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                      <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                </v-list-tile-action>
            </v-list-tile>
          </v-list>

          <!-- <v-list nopadding margin-top-ten v-if="userType=='IsSupportUser'"> -->
          <v-list nopadding margin-top-ten v-if="!$root.fn_isProductionApp() || userType=='IsSupportUser'">
            <v-list-tile v-ripple to="/settings/temporary_businesses">
                <v-list-tile-action>
                    <v-icon class="primary-color">business</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                    <v-list-tile-title>Temporary Businesses</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                    <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                </v-list-tile-action>
            </v-list-tile>

            <v-divider></v-divider>

            <v-list-tile v-ripple to="/settings/developeroptions">
                <v-list-tile-action>
                    <v-icon class="primary-color">face</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                    <v-list-tile-title>Developer Options</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                    <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                </v-list-tile-action>
            </v-list-tile>


            <!-- <v-list-tile v-ripple @click="fn_generateBarcode">
                <v-list-tile-action>
                    <v-icon class="primary-color">face</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                    <v-list-tile-title>Generate Barcode</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                    <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                </v-list-tile-action>
            </v-list-tile>

            <v-list-tile v-ripple @click="fn_designBarcode">
                <v-list-tile-action>
                    <v-icon class="primary-color">face</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                    <v-list-tile-title>Design Barcode</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                    <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                </v-list-tile-action>
            </v-list-tile>

            <v-list-tile v-ripple @click="fn_barcodeLabelTemplates">
                <v-list-tile-action>
                    <v-icon class="primary-color">face</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                    <v-list-tile-title>Barcode Label Templates</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                    <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                </v-list-tile-action>
            </v-list-tile> -->
          </v-list>

       </div>

       <dialog-rating ref="ref_dialogRating" :closeDialog="fn_closeDialogRating" :save="fn_saveRating"></dialog-rating>

       <v-dialog v-model="freeDialog" v-if="freeDialog" no-click-animation persistent max-width="290">
	      <v-card>
	        <v-card-text class="pa-4" center-align>
            <img src="../../assets/FreeIcon_96x96.png"/>
            <p class="title">Free</p>
            <p>Completely free – free mobile app and desktop application, also give access to your accountant for free</p>
          </v-card-text>
        </v-card>
	    </v-dialog>

      <dialog-confirmation ref="ref_dialogConfirmation" :header="confirmationHeader" :confirmationMessage="'Your connection with client business <strong>' + $root.CurrentBusiness.BusinessName + '</strong> will be disconnected'" :actionMethod="fn_disconnect" okBtnText="Continure" cancelBtnText="Cancel"></dialog-confirmation>

</div>
</template>

<script>
let tagId = 'settings'

// import VRuntimeTemplate from "v-runtime-template";

// import runtimetest from './runtimetest'

// import reportDialog from '../newreports/dialogs/dialog_gstr_report'
// import {openingDateMixin} from './opening_date_mixin'
// import dialogDatePickerOpening from '../transactions/forms/dialogs/dialog_datepicker_opening'
import dialogRating from '../dialogs/dialog_rating'
import dialogConfirmation from '../dialogs/dialog_confirmation'
const navigationMenu = require('../../config.js').configs.bottomNavigation;

  export default{
    // mixins: [openingDateMixin],
    data(){
      return{
        bottomsheet:false,
        shortBusinessName :null,
        isTemporarySetup:false,
        userType:null,
        isBackupRunning:false,
        freeDialog:false,
        isScannerOpen:false,
        confirmationHeader:null
        // unreadTicketObj:null
      }
    },
    components:{
      // 'report-dialog': reportDialog,
      // 'dialog-datepicker-opening':dialogDatePickerOpening
      'dialog-rating':dialogRating,
      'dialog-confirmation': dialogConfirmation
    },

    watch: {
      '$root.selectedLanguage': function(){
        this.fn_setBottomNavigation();
      }
    },

    methods:{

        fn_redirectToWhatsApp: function(){
          this.$root.fn_openExternalUrl("https://api.whatsapp.com/send?phone=918882741212");
        },

        fn_requestCall: function(){
          this.$root.fn_openExternalUrl("https://api.whatsapp.com/send?phone=918882741212&text=Call me back");
        },

        fn_sendInvite: function(){
          this.$router.push({path:'/settings/sendinvitation'});
        },

        fn_updateBusiness: function(type){
            if(type=='register'){
                this.$router.push({path:'/registration/business/'+this.$root.CurrentBusiness.BusinessID+'/edit', query:{usertype:this.$root.CurrentBusiness.UserType}});
            }
            else{
                this.$router.push({path:'/registration/business/'+this.$root.CurrentBusiness.BusinessID+'/edit'});
            }
        },

        fn_openDialogConfirmation: function(header){
          if(this.$root.clientConnectionStatus == 'Connected'){
            this.confirmationHeader = header;
            this.$refs['ref_dialogConfirmation'].openDialogWeb();
          }
        },

        fn_disconnect: function(){
          this.fn_closeDialog();
          this.$root.fn_disconnectClientConnection(this.confirmationHeader);
        },

        fn_businessProfileSettings: function(){
            if(this.$root.CurrentBusiness.IsAccountantOnly){
                this.$router.push({path:"/settings/accountant/profile"});
            }
            else{
                this.$router.push({path:"/settings/business"});
            }
        },

        fn_businessDetails: function(){
            this.$router.push({path:'/registration/business/'+this.$root.CurrentBusiness.BusinessID+'/details'});
        },

      fn_syncNow: function(){
        if(!navigator.onLine){
          this.showToast("Internet not available");
          return;
        }

        if(!this.$root.CurrentBusiness.DataDrive){
          this.$router.push({path:"/registration/business/setupdrive"});
        }
        else{
          this.isBackupRunning = true;
          this.$root.fn_startSync();
        }
       
      },

      fn_openDialogRating: function(){
        this.$refs['ref_dialogRating'].openDialogWeb();
      },

      fn_saveRating: function(rate){
        if(rate<5){
            this.$router.push({path:'/settings/feeback/'+rate});
            this.showToast("Let us know, what we can do better?");
        }
        else{
            this.getData("OpenPlayStore", null, 
                {
                    onSuccess: function(response){
                        console.log(response);
                    }, 
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        }
      },

      fn_closeDialogRating: function(){
        this.$refs['ref_dialogRating'].dialog_rating = false;
      },

      fn_connectionRequests: function(){
          this.$router.push({path:"/settings/connectionrequest/items"});
      },

      fn_accountant: function(){
        // if(!this.$root.CurrentBusiness.DataDrive){
        //   this.showToast("Set up backup drive to add accountant access");
        //   return;
        // }
        
        this.$router.push({path:"/settings/accountant/items"});
      },

      fn_checkNotificationPermissionStatus: function(){
        let self = this;
        this.getData('NotificationPermissionStatus', null, {
          onSuccess: function(response){
              console.log(response);
              if(!JSON.parse(response)){
                self.fn_openNotificationPermission();
              }
              else{
                self.fn_scanQRCode();
              }
          }, 
          onError: function(error){
              console.log(error);
          }
        });
      },
      
      fn_openNotificationPermission: function(){
        let self = this;
        this.getData('CheckNotificationPermission', null, {
          onSuccess: function(response){
              console.log(response);
              self.fn_scanQRCode();
          }, 
          onError: function(error){
              console.log(error);
          }
        });
      },

      fn_scanQRCode: function(){

        // if(!this.$root.CurrentBusiness.DataDrive && !this.$root.CurrentBusiness.IsAccountantOnly && process.env.NODE_ENV != 'development'){
        //     this.$router.push({path:"/registration/business/setupdrive"});
        //     this.showToast("Set up backup drive for desktop login");
        //     return;
        // }

        if(this.isScannerOpen){
          return;
        }
        this.isScannerOpen = true;

        setTimeout(() => {
          this.isScannerOpen = false;
        }, 1000);

        let self = this;

        this.showLoading("Please wait...");

        this.$root.fn_getAuthToken(function(token){
          
          self.hideLoading();

          let postObj = {}
          postObj.token = token;
        //   postObj.BusinessID = self.$root.CurrentBusiness.BusinessID;
        //   postObj.token = token;
        //   postObj.IsTemporary = self.$root.CurrentBusiness.temporaryBusiness ? true : false;

          if(self.$root.CurrentBusiness.temporaryBusiness){
            //   postObj.IsTemporary = true;
              postObj.BusinessID = null;
              postObj.TempBusinessID = self.$root.CurrentBusiness.BusinessID;
          }
          else{
            //   postObj.IsTemporary = false;
              postObj.BusinessID = self.$root.CurrentBusiness.BusinessID;
              postObj.TempBusinessID = null;
          }

          postObj.subject = self.$t('settings.qrShare.desktopSubject');
          postObj.body = self.$t('settings.qrShare.desktopBody');
          // postObj.email = "testemail@gmail.com";

          postObj.toolbarTitle = self.$t('settings.main.desktopLogin');
          postObj.heading1 = self.$t('settings.qrShare.desktopHeading1');
          postObj.heading2 = self.$t('settings.qrShare.desktopHeading2');
          postObj.shareMessage = self.$t('settings.qrShare.shareLinkOnEmail');
          postObj.permissionTitle = self.$t('settings.qrShare.grantPermission');
          postObj.message = self.$t('settings.qrShare.cameraPermissionMessage');
          postObj.positiveBtnText = self.$t('settings.qrShare.grant');
          postObj.negativeBtnText = self.$t('settings.qrShare.cancel');

          self.postServerData('DesktopLogin', postObj, 
              {
                onSuccess: function(response){
                  console.log(response);
                  self.isScannerOpen = false;
                  self.showToast("QR code scanned successfully");
                }, 
                onError: function(error){
                  self.isScannerOpen = false;
                  console.log(error);
                }
              }
            ); 
        });
      },

      fn_getUserType : function(){
        let self = this;
        this.getData('UserType', null, 
            {
              onSuccess: function(response){
                  console.log(response);
                  self.userType = response;
              }, 
              onError: function(error){
                  console.log(error);
                  self.userType = null;
              }
            }
        );
      },

      // fn_getUnreadTicketsCount: function(){
      //   if(!navigator.onLine){
      //     this.showToast('Internet not available');
      //     return;
      //   }

      //   let self = this;
      //   this.$root.fn_getAuthToken(function(token){
      //     let filterObject = {};
      //     filterObject.BusinessID = self.$root.CurrentBusiness.BusinessID;
      //     filterObject.token = token;
      //     self.getServerData('UnreadTicketsCount', filterObject, 
      //         {
      //             onSuccess: function(response){
      //                 self.hideLoading();
      //                 self.unreadTicketObj = JSON.parse(response);
      //             }, 
      //             onError: function(error){
      //                 console.log(error);
      //                 self.hideLoading();
      //                 if(typeof JSON.parse(error) == 'object'){
      //                     let response = JSON.parse(error);
      //                     self.showToast(response.Message);
      //                 }
      //             }, 
      //         }
      //     );    
      //   });
      // },

      // fn_openSupport: function(type, unreadCount){

      //   if(!navigator.onLine){
      //     this.showToast('Internet not available');
      //   }

      //   var self = this;
      //   let postObj = {};

      //   if(type == 'support'){
      //     postObj.url = "https://bizops-support.web.app/support/supportteam/items?businessid="+this.$root.CurrentBusiness.BusinessID;
      //     // postObj.url = "http://192.168.43.101:8080/support/supportteam/items?businessid="+this.$root.CurrentBusiness.BusinessID;
      //   }
      //   else if(type == 'customer'){
      //     if(unreadCount && this.unreadTicketObj && this.unreadTicketObj.Count == 1){
      //       postObj.url = "http://192.168.43.101:8080/support/appsupport/tickets/"+this.unreadTicketObj.Tickets[0].SupportTicketID+"?unread=1";
      //     }
      //     else{
      //       postObj.url = "https://bizops-support.web.app/support/appsupport/tickets/items?businessid="+this.$root.CurrentBusiness.BusinessID;
      //       // postObj.url = "http://192.168.43.101:8080/support/appsupport/tickets/items?businessid="+this.$root.CurrentBusiness.BusinessID;
      //     }
      //   }

      //   this.postData('ShowSupportView', postObj,
      //     {
      //       onSuccess: function(response){
      //         console.log(response);
      //       },
      //       onError: function(error){
      //         console.log(error);
      //         self.showToast('Something went wrong. Try again!.');
      //       }
      //     });
      // },

      fn_reopenDB: function(businessid){
            let self = this;
            let bid = businessid && businessid != "null" ? businessid : this.$root.CurrentBusiness.BusinessID;
            this.getData('ReopenDataBase', bid, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        console.log("Restore Complete");

                        let isDbRestored = AndroidRoutingTest.isDbRestored();
                        if(JSON.parse(isDbRestored)){
                          AndroidRoutingTest.dbRestored('false');
                          self.fn_toggleDataShare();
                        }
                        
                        self.$root.fn_getBusiness(null, null, function(){
                          console.log("Get business data via AllBusiness");
                          // checking is temporary business setup or not
                          // self.fn_checkTemporarySetup();
                        });
                    }, 
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        fn_toggleDataShare: function(){
            let filterObj = {};
            filterObj.businessId = this.$root.CurrentBusiness.BusinessID;
            filterObj.IsTemporary = this.$root.CurrentBusiness.temporaryBusiness ? true : false;
            let toggleValue = false;
            this.getFilterData("WatchForegroundService", JSON.stringify(toggleValue), filterObj,
                {
                    onSuccess: function(response){
                        console.log(response);
                    }, 
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

      // fn_supportList: function(){
      //   if(!navigator.onLine){
      //     this.showToast('Internet not available');
      //     return;
      //   }

      //   this.$router.push("/settings/support");
      // },

      fn_encryptData: function(){

        const plainText = "this is my plain text";

        const key = "1234567812345678";

        const cryptLib = require('@skavinvarnan/cryptlib');

        const cipherText = cryptLib.encryptPlainTextWithRandomIV(plainText, key);
        console.log('cipherText %s', cipherText);

        // var crypto = require('crypto');

        // var mykey = crypto.createCipher('AES/ECB/PKCS7Padding', '1234567812345678');
        // var mystr = mykey.update('abc', 'utf8', 'hex');
        // mystr += mykey.final('hex');

        // console.log(mystr); 

        let self = this;
        this.decryptData('DecryptData', key, cipherText, 
          {
            onSuccess: function(response){
              console.log(response);
            }, 
            onError: function(error){
              console.log(error);
            }
          });
      },

      fn_startStopService: function(serviceType){
          let self = this;
          this.getData(serviceType, null, 
              {
                  onSuccess: function(response){
                      console.log(response);
                  }, 
                  onError: function(error){
                      console.log(error);
                  }
              }
          );
      },

      // fn_functionTest: function(){
      //     this.getData('FunctionTest', null, 
      //         {
      //             onSuccess: function(response){
      //               console.log(response);
      //             }, 
      //             onError: function(error){
      //               console.log(error);
      //             }
      //         }
      //     );
      // },

      // fn_copyDbFile: function(){
      //     let self = this;
      //     this.getData('CopyDbFile', this.$root.CurrentBusiness.BusinessID, 
      //         {
      //             onSuccess: function(response){
      //                 console.log(response);
      //             }, 
      //             onError: function(error){
      //                 console.log(error);
      //             }
      //         }
      //     );
      // },

      fn_changeBusiness: function(){
        this.$router.push({path:"/settings/business/mybusiness"});
      },

      fn_sendFeedback: function(){
        this.$router.push({path:"/settings/feeback/4"});
      },

      fn_shareApp: function(){
        let self = this;
        let filterObj = {};
        filterObj.subject = this.$t('settings.qrShare.shareAppSubject');
        filterObj.text = this.$t('settings.qrShare.shareAppText');
        this.getFilterData('ShareApp', null, filterObj, 
            {
                onSuccess: function(response){
                    console.log(response);
                }, 
                onError: function(error){
                    console.log(error);
                }
            }
        );
      },

      // fn_shareApp: function(){
      //   let self = this;
      //   this.getData('ShareApp', null, 
      //       {
      //           onSuccess: function(response){
      //               console.log(response);
      //           }, 
      //           onError: function(error){
      //               console.log(error);
      //           }
      //       }
      //   );
      // },

      fn_closeDialog: function(){
        this.$refs['ref_dialogConfirmation'].closeDialogWeb();
        // this.$refs['ref_dialogDatePickerOpening'].datepicker = false;
      },

      fn_clearData: function(){

        if(!this.$root.CurrentBusiness.DataDrive){
          this.showToast("Please first set up backup drive");
          return;
        }

        this.$router.push({path:"/settings/cleardata"});
      },

      // fn_checkTemporarySetup: function(){
      //   let self = this;
      //   this.getData('CheckTemporaryBusiness', this.$root.CurrentBusiness.BusinessID, 
      //       {
      //           onSuccess: function(response){
      //               console.log(response);
      //               self.isTemporarySetup = JSON.parse(response);
      //           }, 
      //           onError: function(error){
      //               console.log(error);
      //           }
      //       }
      //   );
      // },

      // fn_removeTemporarySetup: function(){
      //   let self = this;
      //   this.getData('RemoveTemporaryBusiness', this.$root.CurrentBusiness.BusinessID, 
      //       {
      //           onSuccess: function(response){
      //               console.log(response);
      //               self.isTemporarySetup = false;
      //               self.showToast("Temporary business removed");
      //               self.fn_reopenDB(response);
      //           }, 
      //           onError: function(error){
      //               self.fn_reopenDB();
      //               console.log(error);
      //           }
      //       }
      //   );
      // },

      fn_setBottomNavigation : function () {

          console.log('set navigation');

          let self = this;

          let viewObject = {}

          viewObject.NavigationMenu = navigationMenu.map(item => Object.assign({}, item, { Text: this.$t('actions.bottomNav.' + item.Text.toLowerCase()) }));

          this.setBottomNavigation(tagId, viewObject, 
              {
                onSuccess: function (response) {
                  console.log(response);
                  localStorage.setItem('bottomNavigationSet', 1);
                  self.fn_showBottomNavigation();
                },
                onError: function (error) {
                  console.log(error);
                }
              }
          )
      },

      fn_showBottomNavigation: function () {

        let self = this;

        let navigationObject = {activeIndex: 1005};

        this.showBottomNavigation(tagId, navigationObject, 
          {
            onSuccess: function(response){
              console.log(response);
            }, 
            onError: function(error){
              console.log(error);
            }, 
            // onChange: null, 
            onMenuItemClick: function (tagId, menuId, menuAction) {
              self.$root.fn_bottomNavigationItemClick(tagId, menuId, menuAction);
            }
          }
        );
      },

      fn_hideBottomNavigation: function () {

        this.hideBottomNavigation({
            onSuccess: function(response){
              console.log(response);
            }, 
            onError: function(error){
              console.log(error);
            }
          }
        );
        
      },

      fn_showWebView: function () {
        this.showWebView(tagId, {}, 
          {
            onSuccess: function(response){
              console.log(response);
            }, 
            onError: function(error){
              console.log(error);
            }, 
          }
        );
      },

      // fn_generateBarcode: function(){
      //   this.$router.push({path:"/barcode/generator", query:{tagId:this.guidWeb()}});
      //   // this.$router.push({path:"/barcode/config", query:{tagId:this.guidWeb()}});
      // },

      // fn_designBarcode: function(){
      //   // this.$router.push({path:"/barcode/generator", query:{tagId:this.guidWeb()}});
      //   this.$router.push({path:"/barcode/designer", query:{tagId:this.guidWeb()}});
      // },

      // fn_barcodeLabelTemplates: function(){
      //   // this.$router.push({path:"/barcode/generator", query:{tagId:this.guidWeb()}});
      //   this.$router.push({path:"/barcode/items", query:{tagId:this.guidWeb()}});
      // },

      fn_languageSelection: function(){
        this.$router.push({path:"/settings/language"});
      },

      fn_restoreLocalDB: function(){
        this.getData("RESTORE_LOCAL_DB_AS_MAIN", null, 
                {
                    onSuccess: function(response){
                        console.log(response);
                    }, 
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
      },

      fn_goBack: function(){
        if(this.$refs['ref_dialogRating'].dialog_rating){
          this.$refs['ref_dialogRating'].dialog_rating = false;
        }
        else if(this.$refs['ref_dialogConfirmation'].dialog_confimation){
          this.$refs['ref_dialogConfirmation'].dialog_confimation = false;
        }
        else{
          this.exitApp();
        }
      },

    },
    mounted: function () { 
      window.js_globals.fn_onBackPress = this.fn_goBack;
      window.js_globals.fn_reopenDB = this.fn_reopenDB;
      this.isBackupRunning = JSON.parse(AndroidRoutingTest.isBackupRunning());
      this.fn_getUserType();

      if(this.$route.query.sync){
        this.fn_syncNow();
      }
      // this.fn_checkOpening(40001, 40003);
      // this.fn_checkOpening(transactionTypes.openingStock.id, transactionTypes.openingLedger.id);
    },
    beforeRouteLeave(to, from, next){
      if(to.name!="reports" && to.name!="activitytabs" && to.name!="actions" && to.name!="notifications" && to.name!="settings"){
        this.fn_hideBottomNavigation();
      }
      next();  
      // if(this.$refs['ref_dialogRating'].dialog_rating){
      //   this.$refs['ref_dialogRating'].dialog_rating = false;
      //   next(false);
      // }
      // else{
      //   if(to.name!="reports" && to.name!="activitytabs" && to.name!="actions" && to.name!="notifications" && to.name!="settings"){
      //     this.fn_hideBottomNavigation();
      //   }
      //   next();  
      // }
      
    },
    beforeRouteEnter(to, from, next){
      next(vm => {
            if(from.name!="reports" && from.name!="activitytabs" && from.name!="actions" && from.name!="notifications" && from.name!="settings"){
                vm.fn_showWebView();
            }

            if(!vm.$root.CurrentBusiness.IsAccountantOnly){
                // vm.fn_showBottomNavigation();
                let bottomNavigationSet = Number(localStorage.getItem('bottomNavigationSet'))
                console.log(bottomNavigationSet);

                if(bottomNavigationSet){
                    vm.fn_showBottomNavigation();
                }
                else{
                    vm.fn_setBottomNavigation();
                }
            }
            else{
                AndroidRoutingTest.setAccountantAppView(vm.$root.CurrentBusiness.BusinessID);
            }
        })
    }
  }
</script>

<style>
.settings_tab .v-list .v-list__tile{
  min-height: 56px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/settings/settings.vue